import { forwardRef } from '@chakra-ui/react';

import { ButtonGroup, type ButtonGroupProps } from '@frontend/components';

export type DrawerButtonGroupProps = ButtonGroupProps;

export const DrawerButtonGroup = forwardRef<DrawerButtonGroupProps, 'div'>(
  ({ children, size = 'lg', ...restProps }, ref) => {
    return (
      <ButtonGroup justifyContent="end" ref={ref} size={size} {...restProps}>
        {children}
      </ButtonGroup>
    );
  },
);
DrawerButtonGroup.displayName = 'DrawerButtonGroup';
